import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './Component/login';
import AddSalon from './Component/Addsaloon';
import MainPage from './Component/MainPage';
import OfferPage from './Component/Offer';
import Fetchsalon from './Component/Fetchsalon';
import Orderlookup from './Component/Orderlookup';
import Orderpage from './Component/Orderpage';







function App() {
  
  

  

  return (
    <BrowserRouter>
     
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/salon" element={<AddSalon />} />
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/fetchsalon" element={<Fetchsalon />} />
        <Route path="/orderlookup" element={<Orderlookup />} />
        <Route path="/orderpage" element={<Orderpage />} />
        
        
        
       

        
      </Routes>
    </BrowserRouter>
  );
}

export default App;